import { AnimatePresence, motion } from 'motion/react'
import { customerMotionTransition } from '../customer-area'
import { ArrowUpRightIcon, KpiShortcutItem, KpiSkeleton } from './dashboardShared'

type DashboardKpiSectionProps = {
  isBootstrapLoading: boolean
  reducedMotion: boolean
  kpiShortcuts: KpiShortcutItem[]
}

export const DashboardKpiSection = ({ isBootstrapLoading, reducedMotion, kpiShortcuts }: DashboardKpiSectionProps) => (
  <AnimatePresence mode="wait" initial={false}>
    {isBootstrapLoading ? (
      <motion.div
        key="kpi-skeleton"
        initial={reducedMotion ? { opacity: 0 } : { opacity: 0, y: 8 }}
        animate={reducedMotion ? { opacity: 1 } : { opacity: 1, y: 0 }}
        exit={reducedMotion ? { opacity: 0 } : { opacity: 0, y: -8 }}
        transition={customerMotionTransition}
      >
        <KpiSkeleton />
      </motion.div>
    ) : (
      <motion.section
        key="kpi-content"
        initial={reducedMotion ? { opacity: 0 } : { opacity: 0, y: 8 }}
        animate={reducedMotion ? { opacity: 1 } : { opacity: 1, y: 0 }}
        exit={reducedMotion ? { opacity: 0 } : { opacity: 0, y: -8 }}
        transition={customerMotionTransition}
        className="grid gap-3 sm:grid-cols-2 xl:grid-cols-4"
      >
        {kpiShortcuts.map((kpi) => (
          <motion.button
            key={kpi.id}
            type="button"
            onClick={kpi.onClick}
            whileHover={reducedMotion ? undefined : { y: -2 }}
            whileTap={reducedMotion ? undefined : { scale: 0.99 }}
            transition={customerMotionTransition}
            className="ca-card-shell ca-theme-transition group cursor-pointer rounded-xl px-4 py-3 text-left transition-all duration-200 ease-out hover:-translate-y-0.5 hover:scale-[1.01] hover:border-(--color-border-strong) hover:bg-(--color-bg-surface-muted) hover:shadow-(--shadow-md) focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[color-mix(in_srgb,var(--color-focus-ring)_40%,transparent)]"
          >
            <div className="flex items-start justify-between gap-2">
              <p className="text-[11px] font-semibold uppercase tracking-[0.14em] text-(--color-text-muted)">{kpi.label}</p>
              <span className="text-(--color-text-muted) transition-colors duration-200 ease-out group-hover:text-(--color-text-primary)">
                {kpi.icon}
              </span>
            </div>
            <p className="mt-2 text-3xl leading-none font-semibold tracking-tight text-(--color-text-primary)">{kpi.value}</p>
            <div className="mt-2 flex items-center justify-between gap-2">
              <p className="text-xs text-(--color-text-secondary)">{kpi.hint}</p>
              <ArrowUpRightIcon className="h-3.5 w-3.5 text-(--color-text-muted) transition-colors duration-200 ease-out group-hover:text-(--color-text-primary)" />
            </div>
          </motion.button>
        ))}
      </motion.section>
    )}
  </AnimatePresence>
)
